import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from '../../../../../common/services/api'
import { showToast } from '../../../../../common/utils'
import { ALERTS_QUERY_KEY, ALERTS_URL } from '../constants'

type UseAlertDeleteProps = {
  onSuccess?: () => void
}

type UseAlertDeleteReturn = {
  deleteAlert: (id: string) => Promise<unknown>
  isDeleteLoading: boolean
}

export const useAlertDelete = ({
  onSuccess
}: UseAlertDeleteProps = {}): UseAlertDeleteReturn => {
  const queryClient = useQueryClient()

  const { mutateAsync: deleteMutation, isLoading: isDeleteLoading } =
    useMutation<unknown, unknown, string, unknown>(
      [ALERTS_QUERY_KEY, 'delete'],
      (id: string) =>
        postJSON({
          url: `${ALERTS_URL}/${id}`,
          method: 'DELETE',
          responseType: 'text'
        }),
      {
        onSuccess: () => {
          showToast({ title: 'Alert deleted', type: 'success' })
          queryClient.invalidateQueries([ALERTS_QUERY_KEY])
          onSuccess?.()
        },
        onError: (err: any) => {
          showToast({
            title: (err?.message ||
              err?.msg ||
              'Something went wrong') as string,
            type: 'error'
          })
        }
      }
    )

  const deleteAlert = async (id: string) => {
    try {
      return await deleteMutation(id)
    } catch (err) {
      return err
    }
  }

  return { deleteAlert, isDeleteLoading }
}
